export default __webpack_public_path__ + "static/media/apple-carousel-headline-box@2x.45d74e74.png";